import { initGlobalOptions } from '@/components/Argon/Charts/config';
import './roundedCornersExtension';
export default {
  mounted() {
    initGlobalOptions();
  }
};
